import { fetchSameOrigin } from '../Utils';

function cancelAccount(memberId) {
  return fetchSameOrigin(`/members/${memberId}/cancel`, 'PUT')
    .then(resp => resp.json()
    .then(_ => new Promise((resolve) => {
      window.location.reload()
      resolve();
    })
  ));
}

export default cancelAccount;
